const setEst = async (establishment) => {
  let payload = {};
  payload.currentEst = establishment;
  return {...payload};
};

export default setEst;